import { SystemProfileService } from '../shared/system-profile-V2.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { state } from '../shared/state.enum';
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Levels } from 'src/shared/logger/levels.enum';
import { marketsLocations } from '../shared/markets.locations.model';


@Component({
  templateUrl: './insert.systems.component.html',
  styleUrls: ['./insert.systems.component.css'],
  providers: [SystemProfileService]
})
export class InsertUnitsComponent implements OnInit {
  insertedSystemsText: string;
  insertedSystems: {} = {};
  targetFolder: { id: Number, text: string } = { id: null, text: "" };
  folderAddError: string = "";

  marketsData: marketsLocations[] = [];
  availableMarkets: { id: Number, text: string }[] = [];
  selectedMarketName: string = "";
  availableMarketLocations: { id: Number, text: string }[] = [];
  selectedMarketLocationId: { id: Number, text: string } = { id: null, text: null };
  provisionUnitsChoice: number = 0;
  monitorUnitsChoice: number = 0;

  displayedColumns = ["deleteIcon", "ip", "password", "targetFolder", "market", "location", "provision", "monitor", "state"];
  rowsCounter = 0;
  processingFlag: boolean = false;
  resultReceivedFlag: boolean = false;
  disableAfterFetchingData: boolean = false;
  StateEnum = state;
  @ViewChild('f') insertForm: NgForm;
  @ViewChild('ff') submitForm: NgForm;


  constructor(
    public dialogRef: MatDialogRef<InsertUnitsComponent>,
    private systemService: SystemProfileService,
    private loggerService: LoggerService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.systemService.getMarketsLocationsAvailable().subscribe(data => {
      this.marketsData = data.data;
      for (const market of this.marketsData) {
        if (this.availableMarkets.length == 0) this.availableMarkets.push({ id: market.id, text: market.market_name });
        else {
          if (this.availableMarkets[this.availableMarkets.length - 1].text !== market.market_name) this.availableMarkets.push({ id: market.id, text: market.market_name });
        }
      }
    }, err => {
      this.loggerService.log("InsertUnitsComponent", err.message, Levels.error)
    })
  }

  recieve_selected_folder(folderDetails) {
    let disableBtn: boolean = false;
    this.folderAddError = "";
    this.targetFolder.id = null;
    this.targetFolder.text = null;
    if (folderDetails && disableBtn == false) {
      if (folderDetails.children && folderDetails.children.length > 0
        && folderDetails.children[0].value.type == 'folder') {
        this.folderAddError = "- Cannot add system to folder that contains folder(s)."
        disableBtn = true;
        return;
      }
    }
    this.targetFolder.id = folderDetails.value.id;
    this.targetFolder.text = folderDetails.text;
  }

  onSubmitTextArea() {
    if (this.insertForm.valid) {
      this.clearTableData()
      let parsedArr: string[] = this.insertedSystemsText.trim().replace(/\n/g, "").split(",");
      for (let i = 0; i < parsedArr.length; i++) {
        if (parsedArr[i].includes("-")) {
          let candidateEle: string[] = parsedArr[i].split("-");
          if (candidateEle.length == 2) {
            let key = this.rowsCounter++;
            this.insertedSystems[key] = [candidateEle[0].replace(/ /g, ''), candidateEle[1].replace(/ /g, ''), null]
          }
        }
      }

    }
  }

  onSubmitData() {
    if (this.submitForm.valid && this.targetFolder.id) {
      this.processingFlag = true;
      this.resultReceivedFlag = false;
      this.disableAfterFetchingData = true;

      let dataObject: {
        targetFolderId: Number, marketLocationId: Number, provisionFlag: Number,
        monitorFlag: Number, units: { dictId: string, system_ip: string, system_password: string }[]
      } = {
        targetFolderId: this.targetFolder.id, marketLocationId: this.selectedMarketLocationId.id,
        provisionFlag: this.provisionUnitsChoice, monitorFlag: this.monitorUnitsChoice, units: []
      }
      for (const prop in this.insertedSystems) {
        let obj = this.insertedSystems[prop]
        dataObject.units.push({ dictId: prop, system_ip: obj[0], system_password: obj[1] });
      }


      this.systemService.addSystems(dataObject).subscribe(ReceivedData => {
        this.processingFlag = false;
        this.resultReceivedFlag = true;

        for (let i = 0; i < ReceivedData['message'].length; i++) {
          let key: string = ReceivedData['message'][i]["dictId"];
          let stateReceivedEnum: state = ReceivedData['message'][i]["message"];
          this.insertedSystems[key][2] = this.StateEnum[stateReceivedEnum]
        }
        this.openSnackBar("Operation completed", "Success");

      }, err => {
        this.processingFlag = false;
        this.resultReceivedFlag = true;
        for (const prop in this.insertedSystems) {
          let obj = this.insertedSystems[prop]
          obj[2] = this.StateEnum[this.StateEnum.ErrorWhileSendingData]
        }
        this.loggerService.log("InsertUnitsComponent", err.message, Levels.error)
        this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
        this.disableAfterFetchingData = true

      })
    }
  }

  clearTableData() {
    this.insertedSystems = {};
    this.rowsCounter = 0;
    this.processingFlag = false;
    this.resultReceivedFlag = false;
    this.disableAfterFetchingData = false;

  }

  clearTextArea() {
    this.insertedSystemsText = "";
    this.clearTableData();
  }

  getInsertedSystemsKeys(): string[] {
    //set timeout is for the form in order to consider the form touched and show mat-errors automatically
    if (Object.keys(this.insertedSystems).length > 0) {
      setTimeout(x => {
        this.submitForm.form.markAllAsTouched();
      }, 100)
    }

    return Object.keys(this.insertedSystems);
  }

  removeSingleRow(elementID: string) {
    if (!this.processingFlag) {
      delete this.insertedSystems[elementID];
      let element = document.getElementById(elementID + "ID");
      element.parentNode.removeChild(element);
    }
  }

  fetchMarketLocations() {
    this.availableMarketLocations = [];
    this.selectedMarketLocationId = { id: null, text: null };
    const locations = this.marketsData.filter(i => i.market_name == this.selectedMarketName)
    for (const location of locations) {
      this.availableMarketLocations.push({ id: location.id, text: location.location_name });
    }
    this.selectedMarketLocationId = this.availableMarketLocations[0];
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

  changemonitoringselection(){
    if (this.selectedMarketName == 'Not Supported'){
      this.monitorUnitsChoice=0
      return false
    }
    return true
  }
}
